export default __webpack_public_path__ + "./images/do.67a3add8.png";